import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { SectionEditorStoreService } from '../section-editor-store.service';
import { Section, SectionData } from '@urbannex/storethemes';
import { Observable, shareReplay, Subject, takeUntil, tap } from 'rxjs';
import { ThemeEditorStoreService } from '../../../theme-editor/theme-editor-store.service';
import { PreviewEditStoreService } from '../../../../services/preview-edit-store.service';
import { SectionBuilderStoreService } from '../../../sections-editor/shared-section-builder/section-builder-store.service';

@Component({
  selector: 'kve-section-preview',
  templateUrl: './section-preview.component.html',
  styleUrls: ['./section-preview.component.scss']
})
export class SectionPreviewComponent {
  //sectionData: SectionData | null = null;
  private destroy$ = new Subject<void>();
  sectionData$: Observable<SectionData>;
  themeName:string;
  section:Section;
  
  constructor(
    private sectionEditorStoreService:SectionEditorStoreService,
    private previewEditStore:PreviewEditStoreService,
    private themeEditorStore:ThemeEditorStoreService,
    private sectionBuilderState:SectionBuilderStoreService,
    private cdref: ChangeDetectorRef) {
    this.sectionData$ = this.sectionEditorStoreService.sectionData$.pipe(
      takeUntil(this.destroy$),
      tap(data => console.log('sectionData$ emitted:', data)),
      tap(() => console.log('Change detection should trigger now'))
    )
  }

  ngOnInit() {
    this.previewEditStore.selectedSite$.subscribe((site) => {
      console.log('Selected Site:', site);
      const theme = site.theme;
      this.themeName = theme? 'nb-theme-'+theme.name : 'nb-theme-default';
      console.log('Theme Name:', this.themeName);
    });
    this.previewEditStore.selectedSection$.subscribe((section) => {
      console.log(section)
    })
    this.themeEditorStore.themeConfigState$.subscribe((themeConfig) => {
      console.log('Theme Config:', themeConfig);
    })
    /* this.sectionData$
      .pipe(takeUntil(this.destroy$))
      .subscribe((sectionData: SectionData) => {
        console.log('Section Data:', sectionData);
      });
      this.sectionEditorStoreService.sectionData$.pipe(takeUntil(this.destroy$))
      .subscribe((sectionData: SectionData) => {
        console.log('Section Data:', sectionData);
      });
      this.sectionBuilderState.editState$.pipe(takeUntil(this.destroy$))
      .subscribe((editState) => {
        if(editState == 'updated'){
          console.log('Updated Section Data:', editState); 
        }
      }) */
  }
  
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  } 

}
